import { useMemo } from "react";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  nomeEmailFuncionario: string | null;
  centrosCustos: number[] | null;
  centrosCustoDropdown: CentroCustoDropDown[];
  onNomeEmailFuncionarioChange: (value: string) => void;
  onCentrosCustoChange: (value: number[] | null) => void;
  onClearFilters: () => void;
};

export const Header = ({
  nomeEmailFuncionario,
  centrosCustos,
  centrosCustoDropdown,
  onNomeEmailFuncionarioChange,
  onCentrosCustoChange,
  onClearFilters,
}: Props) => {
  const selectedCentroCusto = useMemo(() => {
    if (centrosCustos === null || centrosCustos.length === 0) return null;
    return centrosCustoDropdown.filter(x => centrosCustos.some(y => y === x.id));
  }, [
    centrosCustos,
    centrosCustoDropdown,
  ]);

  return (
    <CascateList title="Filtros" defaultOpen={true}>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-2">
          <DefaultInput
            name="nomeFuncionario"
            label="Nome/Email do Funcionário"
            value={nomeEmailFuncionario}
            onChangeValue={onNomeEmailFuncionarioChange}
          />

          <DefaultMultiAutocomplete
            label="Centro de Custo"
            options={centrosCustoDropdown}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.title}
            value={selectedCentroCusto}
            onChange={e => onCentrosCustoChange(e && e.length > 0 ? e.map(x => x.id) : null)}
          />
        </div>
        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}
